export const visit = (vm, at) => {
at({ "es": { "purchaseMotions": { "pricingPageRedirect": { "button": { "defaultButtonCopy": "Ver precios" } } } } });
};